

import { ChartBar, Clock, PiggyBank, LineChart, DollarSign, BarChart } from "lucide-react";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";

const faqs = [
  {
    question: "Save Time Planning",
    answer: "Automate tasks and streamline your media planning process for faster execution.",
    icon: Clock,
    useCustomIcon: true,
    customIconSrc: "/lovable-uploads/c24b2f04-415a-478c-b5a4-6fb79cf7ec91.png"
  },
  {
    question: "Maximize Budget",
    answer: "Allocate your ad spend more effectively with data-driven insights.",
    icon: PiggyBank,
    useCustomIcon: true,
    customIconSrc: "/lovable-uploads/d42eb12a-75ba-44ee-bd09-c5c74fb5858c.png"
  },
  {
    question: "Simplify Reports",
    answer: "Effortlessly track performance and generate insights to make data-driven decisions faster.",
    icon: LineChart,
    useCustomIcon: true,
    customIconSrc: "/lovable-uploads/fb733bda-fd2a-415c-afb4-71dfdba00e31.png"
  },
  {
    question: "Track Performance",
    answer: "Monitor your performance with up-to-the-minute data to optimize on the fly.",
    icon: BarChart,
    useCustomIcon: true,
    customIconSrc: "/lovable-uploads/008c5ce5-e7bf-4348-af63-526a035cf2b9.png"
  },
  {
    question: "Reduce Ad Spend",
    answer: "Identify underperforming channels and reallocate resources to maximize ROI.",
    icon: DollarSign,
    useCustomIcon: true,
    customIconSrc: "/lovable-uploads/a43a9907-7fce-42ae-a4c5-ff9dff376e9d.png"
  },
  {
    question: "Better Forecasting",
    answer: "Make smarter decisions with precise predictions for future campaigns.",
    icon: ChartBar,
    useCustomIcon: true,
    customIconSrc: "/lovable-uploads/26cb36fd-6de5-4498-9170-e9ada629b3e8.png"
  },
];

const FAQ = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section id="faq" className="py-8 md:py-16 px-6 bg-primary">
      <div 
        ref={ref}
        className={`max-w-6xl mx-auto transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <h2 className="text-[2.25rem] leading-[1.1] md:text-6xl font-medium text-center mb-8 md:mb-16 text-white font-charter">
          Transform Your Marketing<br />
          and Unlock Growth
        </h2>
        
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
          {faqs.map((faq, index) => {
            const Icon = faq.icon;
            return (
              <div 
                key={index} 
                className="bg-white p-3 md:p-8 rounded-3xl hover:shadow-lg transition-all duration-300"
                style={{
                  transitionDelay: `${index * 100}ms`
                }}
              >
                <div className="flex items-center gap-3 md:gap-4 mb-1 md:mb-3">
                  {faq.useCustomIcon ? (
                    <img 
                      src={faq.customIconSrc} 
                      alt={faq.question}
                      className="w-8 h-8 md:w-12 md:h-12 flex-shrink-0" 
                    />
                  ) : (
                    <Icon className="w-5 h-5 md:w-8 md:h-8 text-primary/60 flex-shrink-0" />
                  )}
                  <h3 className="text-base md:text-xl font-medium text-primary leading-tight">{faq.question}</h3>
                </div>
                <p className="text-xs md:text-sm text-secondary">{faq.answer}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
